var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "trigger",
    staticClass: "tooltip-trigger",
    on: {
      "mouseenter": _vm.showTooltip,
      "mouseleave": _vm.hideTooltip,
      "focus": _vm.showTooltip,
      "blur": _vm.hideTooltip
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "tooltip"
    },
    on: {
      "enter": _vm.onEnter,
      "leave": _vm.onLeave
    }
  }, [(_vm.isVisible) ? _c('div', {
    ref: "tooltip",
    staticClass: "material-tooltip",
    class: [_vm.position, _vm.type],
    style: (_vm.tooltipStyles),
    attrs: {
      "role": "tooltip",
      "aria-hidden": !_vm.isVisible
    }
  }, [_c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-arrow",
    style: (_vm.arrowStyles)
  })]) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc5a8076","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Tooltip/Tooltip.vue
// module id = 616
// module chunks = 0